"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentPackageClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const FulfillmentPackageExceptions_1 = require("./FulfillmentPackageExceptions");
const FULFILLMENT_PACKAGE_BASE_URL = process.env.FULFILLMENT_PACKAGE_BASE_URL;
const FULFILLMENT_PACKAGE_BASIC_AUTH_USER = process.env.FULFILLMENT_PACKAGE_BASIC_AUTH_USER;
const FULFILLMENT_PACKAGE_BASIC_AUTH_PASSWORD = process.env.FULFILLMENT_PACKAGE_BASIC_AUTH_PASSWORD;
class FulfillmentPackageClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {
        baseURL: FULFILLMENT_PACKAGE_BASE_URL,
        basicAuthUser: FULFILLMENT_PACKAGE_BASIC_AUTH_USER,
        basicAuthPassword: FULFILLMENT_PACKAGE_BASIC_AUTH_PASSWORD,
    }) {
        super(config);
        if (!config.baseURL) {
            commons_logs_1.log.warn("FULFILLMENT_PACKAGE_BASE_URL environment variable is not set");
        }
        if (!config.basicAuthUser || !config.basicAuthPassword) {
            commons_logs_1.log.warn("FULFILLMENT_PACKAGE_BASIC_AUTH_USER and/or FULFILLMENT_PACKAGE_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async getPackageById(packageId) {
        try {
            return await this.get(`/v1/package/${packageId}`);
        }
        catch (error) {
            if (error.response.status === 404) {
                return undefined;
            }
            throw (0, base_client_1.mapError)(error);
        }
    }
    async getCarrierByTrackingCode(trackingCode) {
        try {
            return await this.get(`/v1/package/trackingCode/${trackingCode}/carrier`);
        }
        catch (error) {
            if (error.response.status === 404) {
                return undefined;
            }
            throw (0, base_client_1.mapError)(error);
        }
    }
    async getPackagesByShipmentIds(shipmentIds) {
        if (shipmentIds.length === 0) {
            return [];
        }
        try {
            const shipmentidsInString = shipmentIds.join(",");
            return await this.get(`/v1/package/shipmentIds/${shipmentidsInString}`);
        }
        catch (error) {
            if (error.response.status === 404) {
                return [];
            }
            throw (0, base_client_1.mapError)(error);
        }
    }
    async getPackageByTrackingCode(trackingCode) {
        try {
            return await this.get(`/v1/package/trackingCode/${trackingCode}`);
        }
        catch (error) {
            if (error.response.status === 404) {
                return undefined;
            }
            throw (0, base_client_1.mapError)(error);
        }
    }
    async trackAndSave(warehouseId, shipmentId, warehousePackages) {
        try {
            return await this.post("/v1/package", {
                warehouseId,
                shipmentId,
                warehousePackages,
            });
        }
        catch (error) {
            throw (0, base_client_1.mapError)(error, [FulfillmentPackageExceptions_1.FulfillmentPackageExceptions.INVALID_PACKAGE, FulfillmentPackageExceptions_1.FulfillmentPackageExceptions.NOT_FOUND]);
        }
    }
    async updateTrackingByTrackingCode(trackingCode, trackingSummary) {
        try {
            await this.post("/v1/package/tracking-update", {
                trackingCode,
                trackingSummary,
            });
        }
        catch (error) {
            throw (0, base_client_1.mapError)(error, [FulfillmentPackageExceptions_1.FulfillmentPackageExceptions.NOT_FOUND]);
        }
    }
    async updatePackageTrackingSummary(trackingCode, trackingSummary) {
        try {
            await this.put(`/v1/package/update-tracking-summary/${trackingCode}`, {
                trackingSummary,
            });
        }
        catch (error) {
            throw (0, base_client_1.mapError)(error);
        }
    }
}
exports.FulfillmentPackageClient = FulfillmentPackageClient;
//# sourceMappingURL=FulfillmentPackageClient.js.map